import { CrmLayoutLogoConfig, CrmLayoutLogoProvider } from '@touch4it/ng-swp/layout-v2';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ProfilesApiService } from '~/api/profiles/profiles-api.service';
import { getMediaResourceUrl } from '~/api/media/media-resource';

@Injectable()
export class LogoProvider extends CrmLayoutLogoProvider {
  private profiles = inject(ProfilesApiService);

  override getComponentConfig(): Observable<CrmLayoutLogoConfig> {
    return this.profiles.currentWorkspace$.pipe(
      map((workspace) => {
        const logo = workspace?.meta?.logos?.find(({ type }) => type === 'workspace_logo_mobile_homescreen');

        if (!logo) {
          return this.config;
        }

        const path = getMediaResourceUrl(logo.ref);
        return { smallLogoPath: path, defaultLogoPath: path };
      }),
    );
  }
}
